import React from "react"
import { Fade as Hamburger } from "hamburger-react"
import { Link } from "gatsby"

import "./mobilenav.css"

class MobileNav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  toggle = toggled => {
    this.setState({
      open: toggled,
    })

    /* Prevent scrolling when menu open */
    if (toggled) {
      document.body.parentElement.style.overflow = "hidden"
    } else {
      document.body.parentElement.style.overflow = ""
    }
  }

  closeMenu = () => {
    this.setState({
      open: false,
    })
    document.body.parentElement.style.overflow = ""
  }

  render() {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Hamburger
          color="#df4154"
          size={28}
          label="Show menu"
          toggled={this.state.open}
          onToggle={this.toggle}
        />
        {
          this.state.open && (
            // <div className={`menu ${this.state.open ? "open" : ""}`}>
            <div className="mobile-hamburgerContainer">
              <a
                href="https://donorbox.org/911textapp-nationwide"
                className="mobile-donate"
              >
                {" "}
                Donate{" "}
              </a>
              <hr />
              <Link to="/" onClick={this.closeMenu}>
                {" "}
                Home{" "}
              </Link>
              <hr />
              <a
                href="/#our-story"
                onClick={e => {
                  e.preventDefault() // prevent default jump
                  this.closeMenu() // close the mobile menu

                  const isHome =
                    window.location.pathname === "/" ||
                    window.location.pathname === "/index.html"

                  if (isHome) {
                    const target = document.getElementById("our-story")
                    const header = document.querySelector(".header-container")
                    const offset = header?.offsetHeight || 150

                    if (target) {
                      const top = target.offsetTop - offset
                      window.scrollTo({ top, behavior: "smooth" })

                      // update the hash without reloading
                      window.history.pushState(null, null, "#our-story")
                    }
                  } else {
                    // Navigate to homepage with hash
                    window.location.href = "/#our-story"
                  }
                }}
              >
                About
              </a>

              <hr />
              <Link to="/how-it-works" onClick={this.closeMenu}>
                {" "}
                How it works{" "}
              </Link>
              <hr />
              <Link to="/press" onClick={this.closeMenu}>
                {" "}
                Press{" "}
              </Link>
              <hr />
              <Link to="/faq" onClick={this.closeMenu}>
                {" "}
                FAQs{" "}
              </Link>
              <hr />

              <Link to="/resources_page" onClick={this.closeMenu}>
                {" "}
                Resources{" "}
              </Link>
              <hr />
              <Link to="/partner" onClick={this.closeMenu}>
                {" "}
                Partner{" "}
              </Link>
              <hr />
              <Link to="/contact" onClick={this.closeMenu}>
                {" "}
                Contact Us{" "}
              </Link>
              <hr />
            </div>
          )
          // </div>
          //our story supporters  how it works faqs resources get involved donate contact us
        }
      </div>
    )
  }
}

export default MobileNav
